<template>
    <transition name="modal">
      <div 
        class="modal">
        <div class="modal__wrapper" @click="$emit('close')">
          <div 
            class="modal-content" 
            @click.stop="">
            <!-- header -->
            <div class="modal-header">
              <span v-if="titleVisible" class="modal-title"> {{ title }} </span>
              <button 
                class="modal-close" 
                @click="$emit('close')"></button>
            </div>
  
            <!-- body -->
            <div class="modal-body">
              <slot name="body"> Default body </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      titleVisible: {
        type: Boolean,
        default: true,
      },
    },
    mounted() {
      document.body.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) this.$emit('close')
      })
    },
    computed: {},
    methods: {},
  }
  </script>